import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { noCase } from "change-case";

class ViewRequest extends Component {
    cancel = () => {
        this.props
            .cancel(this.props.id)
            .then(res => {
                this.props.hideCancel();
            })
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    render() {
        let items = [];
        for (const key in this.props.item) {
            if (this.props.item.hasOwnProperty(key)) {
                // const element = this.props.item[key];
                items.push(
                    <Fragment>
                        {" "}
                        <div className=" text-left   model-html-container mb-2">
                            {noCase(key)}
                        </div>
                        <div className=" text-left   model-html-container">
                            {this.props.item[key]}
                        </div>
                    </Fragment>
                );
            }
        }

        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/ViewRequestModal.png" alt=""></img>
                    </div>

                    <div className="model-content">{items}</div>
                    <div className="model-actions">
                        <button
                            type="button"
                            onClick={this.props.hideViewRequest}
                            className="btn btn-default"
                        >
                            Cancel{" "}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
ViewRequest.contextType = AppContext;
export default ViewRequest;



// WEBPACK FOOTER //
// ./src/components/admin/adminBadges/ViewRequest.js